import type { FC } from "preact/compat";
import type { TextOnlyComponentProps } from "@services/wordpress/wordpress.types";
import { TextReplace } from "../TextReplace";

interface Props {
  paragraphs: TextOnlyComponentProps["paragraphs"];
}

export const TextsComponent: FC<Props> = ({ paragraphs }) => {
  return (
    <>
      {paragraphs?.map((_paragraph, index) => {
        return (
          <p key={index} class="pb-3">
            {_paragraph.text_links ? (
              <TextReplace
                text={_paragraph.text}
                textToReplace={_paragraph.text_links[0].link_placeholder}
                component={
                  <a
                    class="underline text-blue-500"
                    href={`mailto:${_paragraph.text_links[0].link.url}`}
                  >
                    {_paragraph.text_links[0].link.title}
                  </a>
                }
              />
            ) : (
              _paragraph.text
            )}
          </p>
        );
      })}
    </>
  );
};
